/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtListResponse } from '../../models/ddt-list-response';

export interface DdtControllerGetAll$Params {
  identifier?: Array<string>;
  from_date?: string;
  to_date?: string;
  from_registry_office_id?: number;
  registry_end_customer_id?: number;
  related_registry_id?: number;
  related_subject_id?: number;
  related_port_id?: number;
  related_aspect_id?: number;
  related_status_id?: number;
  related_courier_id?: number;
  related_agreement_id?: number;
  related_delivery_id?: number;
  from_shipping_date?: string;
  to_shipping_date?: string;
  tracking_number?: string;
  limit: number;
  skip: number;
  order_by?: string;
  order_direction?: string;
}

export function ddtControllerGetAll(http: HttpClient, rootUrl: string, params: DdtControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('identifier', params.identifier, {});
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('from_registry_office_id', params.from_registry_office_id, {});
    rb.query('registry_end_customer_id', params.registry_end_customer_id, {});
    rb.query('related_registry_id', params.related_registry_id, {});
    rb.query('related_subject_id', params.related_subject_id, {});
    rb.query('related_port_id', params.related_port_id, {});
    rb.query('related_aspect_id', params.related_aspect_id, {});
    rb.query('related_status_id', params.related_status_id, {});
    rb.query('related_courier_id', params.related_courier_id, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('related_delivery_id', params.related_delivery_id, {});
    rb.query('from_shipping_date', params.from_shipping_date, {});
    rb.query('to_shipping_date', params.to_shipping_date, {});
    rb.query('tracking_number', params.tracking_number, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtListResponse;
      }>;
    })
  );
}

ddtControllerGetAll.PATH = '/ddt';
